import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import pick from 'lodash/pick';
import { getSuffix } from '../../../../lib/apiKeys';
import a from '../../../../redux/actions';
import s from '../../../../redux/selectors';
import types from '../../../../types';

const InlineInput = ({
  inputProps,
  maxLength,
  inputValue,
  apiKey,
  updateNumericInput,
  currency,
  percent,
  ariaLabel,
  locale,
  period,
}) => {
  const inputSuffix = getSuffix(apiKey);
  const style = { width: `${maxLength + 1}rem` };
  return (
    <span style={{ whiteSpace: 'nowrap' }} className="action-details__inline-input">
      &nbsp;
      {currency && locale !== 'fr' && <span>$</span>}
      <input
        aria-label={ariaLabel || apiKey}
        maxLength={maxLength}
        style={style}
        placeholder={inputValue.defaultDisplay}
        value={inputValue.inputDisplay}
        onChange={(e) => {
          e.preventDefault();
          updateNumericInput({ [inputSuffix]: e.target.value }, 'input_takeaction');
        }}
        {...inputProps}
      />
      {percent && <span>&nbsp;%</span>}
      {currency && locale === 'fr' && <span>&nbsp;$</span>}
      {period && '.'}
      &nbsp;
    </span>
  );
};

InlineInput.propTypes = {
  // ownProps
  apiKey: PropTypes.string.isRequired,
  inputProps: PropTypes.shape({}),
  currency: PropTypes.bool,
  percent: PropTypes.bool,
  maxLength: PropTypes.number,
  ariaLabel: PropTypes.string,
  // connected props
  inputValue: types.UserInput.isRequired,
  updateNumericInput: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  period: PropTypes.bool,
};

InlineInput.defaultProps = {
  inputProps: {},
  currency: false,
  percent: false,
  period: false,
  maxLength: 4,
  ariaLabel: '',
};

const mapStateToProps = (state, ownProps) => [
  'inputValue',
  'locale',
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state, ownProps),
}), {});

const mapDispatchToProps = dispatch => bindActionCreators(
  pick(a, [
    'updateNumericInput',
  ]),
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(InlineInput);
